import http from '@/utils/http';
import axios from 'axios';

const URL_BASE = '/certificacao';

export default {
    buscarTerritorioFiltroCertificacao(filtro) {
        return http.post({
            url: URL_BASE + `/territorio/filtro`,
            data: {
                filtro
            },
            lockScreen: false
        });
    },

    enviarArquivosCertificacaoTerritorio(formData) {
        const url = `/arquivoCertificacaoTerritorio/upload`;

        return http.post({
            url,
            data: {
                formData
            },
            lockScreen: true,
            lockMessage: 'Enviando arquivos para certificação.'
        });
    },

    marcarComoCertificado(idCertificado, idTerritorio) {
        return http.get({
            url:
                URL_BASE +
                `/certificar/${idCertificado}/territorio/${idTerritorio}`,
            lockScreen: true
        });
    },

    exportarRelatorioXlsx(dados, params) {
        const fileLink = document.createElement('a');
        try {
            return http
                .post({
                    url:
                        URL_BASE +
                        `/territorio/exportar-relatorio?page=${params.page}&size=${params.size}&sort=${params.sort},${params.por}`,
                    data: dados,
                    responseType: 'blob',
                    lockScreen: true,
                    lockMessage: 'Preparando dados para download'
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;
                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    buscarTipoCertificacao() {
        return http.get({
            url: URL_BASE + `/tipo`,
            lockScreen: false
        });
    },

    InserirCertificacaoTerritorio({
        idTerritorio,
        idCertificacaoTipo,
        nomeTerritorioCar
    }) {
        return http.post({
            url: URL_BASE + `/inserir`,
            data: {
                idTerritorio,
                idCertificacaoTipo,
                nomeTerritorioCar
            },
            lockScreen: false,
            lockMessage: 'Enviando territórios certificados para análise.'
        });
    },

    buscarCertificacoes(dados, params, lockScreen = false) {
        return http.post({
            url:
                URL_BASE +
                `/territorio/listagem-certificacao?page=${params.page}&size=${params.size}&sort=${params.sort},${params.por}`,
            data: dados,
            lockScreen
        });
    },

    buscarCertificacoesV2(dados, params, lockScreen = false) {
        return http.post({
            url:
                URL_BASE +
                `/territorio/listagem-certificacao-v2?page=${params.page}&size=${params.size}&sort=${params.sort},${params.por}`,
            data: dados,
            lockScreen: false
        });
    },

    buscarDadosLotes(params) {
        return http.get({
            url: `${URL_BASE}/lote?page=${params.page}&size=${params.size}`,
            lockScreen: false
        });
    },

    cadastrarViaPlanilha(planilha, idsCertificacaoTipo) {
        const url =
            process.env.VUE_APP_HTTP_PATH + URL_BASE + '/inserir-planilha';

        const formData = new FormData();
        formData.append('planilha', planilha.raw);
        formData.append('idsCertificacaoTipo', idsCertificacaoTipo);
        return axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    processarPlanilha(id) {
        return http.post({
            url: URL_BASE + `/processar-planilha?id=${id}`,
            data: {},
            lockScreen: false
        });
    },

    downloadPlanilhaComErro(id) {
        const fileLink = document.createElement('a');
        try {
            return http
                .get({
                    url: URL_BASE + `/download-planilha-erro/${id}`,
                    responseType: 'blob',
                    lockScreen: false
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;

                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    buscarDadosDetalhamentoAnalise(id) {
        return http.get({
            url: URL_BASE + `/detalhamento-analise/${id}`,
            lockScreen: true
        });
    },

    buscarResultadoDiagnosticoAnaliseCertificacao(
        idCertificacaoTerritorio,
        idCertificacaoTerritorioTipo
    ) {
        return http.get({
            url:
                URL_BASE +
                `/diagnosticosCertificacaoTerritorio/${idCertificacaoTerritorio}/tipo/${idCertificacaoTerritorioTipo}`,
            lockScreen: true
        });
    },

    removerCertificacao(id) {
        return http.post({
            url: URL_BASE + `/remover/${id}`,
            data: {},
            lockScreen: false
        });
    },

    buscarDadosTerritorio(idCertificacao) {
        return http.get({
            url: URL_BASE + `/dados-territorio/${idCertificacao}`,
            lockScreen: true
        });
    },

    deletarArquivosCertificacao(idArquivo) {
        return http.delete({
            url: `/arquivoCertificacaoTerritorio/delete/${idArquivo}`,
            lockScreen: true
        });
    },

    buscarDadosAreaPlantio(id) {
        return http.get({
            url: URL_BASE + `/dados-area-plantio/${id}`,
            lockScreen: true
        });
    },

    buscarTotalizadoresCertificacao() {
        return http.get({
            url: URL_BASE + `/totalizadores`,
            lockScreen: false
        });
    },

    exportarPdfAnaliseResumida(idCertificacao) {
        return http.get({
            url: `${URL_BASE}/exportar/pdf/analise-resumida/${idCertificacao}`,
            lockScreen: false
        });
    },

    exportarPdfAnaliseCompleta(idCertificacao) {
        return http.get({
            url: `${URL_BASE}/exportar/pdf/analise-completa/${idCertificacao}`,
            lockScreen: false
        });
    },

    solicitarLaudo(id) {
        return http.post({
            url: URL_BASE + `/solicitar-laudo`,
            data: {
                id
            },
            lockScreen: false,
            lockMessage: 'Enviando solicitação de laudo.'
        });
    },

    inserirManual(data) {
        return http.post({
            url: URL_BASE + '/manual/inserir',
            data,
            lockScreen: false
        });
    }
};
